export const EMBARCACAO_DETAIL_EXPORT_LABEL = "Exportar";
export const EMBARCACAO_DETAIL_EXPORT_WAITING_TITLE = "Aguarde o carregamento de todas as seções";
